import React from 'react';
import { Box, Tabs, Tab, Paper } from '@mui/material';

import PurchaseOrderUI from './components/biReports/PurchaseOrderUI';
import PurchaseReceiptUI from './components/biReports/PurchaseReceiptUI';
import ProductSupplierInfoPage from './components/biReports/InventoryProdSupplier';
import { createOrderProposalDraft } from './components/biReports/PurchaseOrderRecommendationUI';
import RawMaterialConsumption from 'components/biReports/InventoryRMConsumption';
import SocrateErrorsDialog from './components/biReports/SocrateErrorsDialog';

function TabPanel(props) {
  const { children, value, index, sx, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`invclose-tabpanel-${index}`}
      aria-labelledby={`invclose-tab-${index}`}
      sx={{
        display: value === index ? 'flex' : 'none',
        flexDirection: 'column',
        width: '100%',
        minWidth: 0,
        minHeight: 0,
        ...sx,
      }}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            pt: { xs: 0.25, sm: 0.35, md: 0.5 },
            width: '100%',
            height: '100%',
            maxHeight: '100%',
            minWidth: 0,
            minHeight: 0,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {children}
        </Box>
      )}
    </Box>
  );
}

function a11yProps(index) {
  return {
    id: `invclose-tab-${index}`,
    'aria-controls': `invclose-tabpanel-${index}`,
  };
}

class InventorySupplyTabs extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tab: 0,
      proposalDraft: createOrderProposalDraft(),
      // If you decide to share filters later, lift them here and pass as props
      // filters: { period: dayjs().format('YYYY-MM'), location: '', product: '' }
    };
  }

  componentDidMount() {
    if (this.props.onReady) {
      this.props.onReady();
    }
  }

  handleTabChange = (_e, newValue) => {
    this.setState(previous => {
      const leavingOrders = previous.tab === 0 && newValue !== 0;
      if (!leavingOrders) {
        return { tab: newValue };
      }
      return {
        tab: newValue,
        proposalDraft: createOrderProposalDraft(),
      };
    });
  };

  handleProposalDraftChange = (proposalDraft) => {
    this.setState({ proposalDraft });
  };

  render() {
    const { tab } = this.state;
    const fixedTabSx = {
      p: {
        xs: 0.5,
        sm: 1,
      },
      height: {
        xs: 'calc(100dvh - 128px)',
        sm: 'calc(100dvh - 140px)',
        md: 700,
        lg: 740,
      },
      maxHeight: {
        xs: 'calc(100dvh - 128px)',
        sm: 'calc(100dvh - 140px)',
        md: 700,
        lg: 740,
      },
      minHeight: 0,
      overflow: 'hidden',
    };

    const fixedChildSx = {
      width: '100%',
      height: '100%',
      maxHeight: '100%',
      minWidth: 0,
      minHeight: 0,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
    };

    return (
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: {
            xs: 'calc(100vw - 8px)',
            sm: '100%',
          },
          maxWidth: {
            xs: 'calc(100vw - 8px)',
            sm: '100%',
          },
          ml: {
            xs: 'calc(50% - 50vw + 4px)',
            sm: 0,
          },
          overflowX: 'hidden',
          bgcolor: '#f3f6fa',
          pt: { xs: 0.25, sm: 0.5, md: 0.75 },
          pb: { xs: 0.25, sm: 0.5, md: 0.75 },
          px: { xs: 0.5, sm: 0.85, md: 1 },
          boxSizing: 'border-box',

          '& .MuiCard-root': {
            maxWidth: '100%',
            boxSizing: 'border-box',
            borderRadius: { xs: '14px', sm: '16px' },
          },

          '& .MuiPaper-root': {
            maxWidth: '100%',
            boxSizing: 'border-box',
          },

          '& table': {
            maxWidth: '100%',
          },
        }}
      >
        <Paper
          elevation={0}
          sx={{
            position: 'sticky',
            top: 0,
            zIndex: 10,
            width: '100%',
            minWidth: 0,
            overflow: 'hidden',
            mb: { xs: 0.25, sm: 0.35, md: 0.5 },
            borderRadius: { xs: '12px', sm: '14px' },
            border: '1px solid rgba(15, 23, 42, 0.08)',
            boxShadow: '0 3px 10px rgba(15, 23, 42, 0.07)',
            bgcolor: 'rgba(248,250,252,0.98)',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
            <Tabs
              value={tab}
              onChange={this.handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              aria-label="Inventory Supply Tabs"
              sx={{
                flexGrow: 1,
                minWidth: 0,
                minHeight: { xs: 42, sm: 46 },
                px: { xs: 0.5, sm: 1 },
                '& .MuiTabs-scroller': {
                  overflowX: 'auto !important',
                },
                '& .MuiTabs-indicator': {
                  height: 3,
                  borderRadius: 2,
                },
                '& .MuiTab-root': {
                  minHeight: { xs: 42, sm: 46 },
                  textTransform: 'none',
                  fontWeight: 700,
                  fontSize: { xs: 12.5, sm: 13.5 },
                  px: { xs: 1.1, sm: 1.6 },
                  whiteSpace: 'nowrap',
                },
              }}
            >
              <Tab label="Orders" {...a11yProps(0)} />
              <Tab label="Receipts" {...a11yProps(1)} />
              <Tab label="Prod Supply" {...a11yProps(2)} />
              <Tab label="RM Cons" {...a11yProps(3)} />
            </Tabs>
            <SocrateErrorsDialog />
          </Box>
        </Paper>

        <Box
          sx={{
            width: '100%',
            maxWidth: '100%',
            minWidth: 0,
            overflow: 'hidden',
            flex: 1,
            minHeight: 0,
            '& > div': {
              width: '100%',
              maxWidth: '100%',
              minWidth: 0,
            },
            '& .MuiCard-root': {
              boxShadow: '0 4px 14px rgba(15, 23, 42, 0.08)',
              border: '1px solid rgba(15, 23, 42, 0.06)',
            },
          }}
        >
          <TabPanel value={tab} index={0} sx={fixedTabSx}>
            <Box sx={fixedChildSx}>
              <PurchaseOrderUI
                proposalDraft={this.state.proposalDraft}
                onProposalDraftChange={this.handleProposalDraftChange}
              />
            </Box>
          </TabPanel>

          <TabPanel value={tab} index={1} sx={fixedTabSx}>
            <Box sx={fixedChildSx}>
              <PurchaseReceiptUI />
            </Box>
          </TabPanel>

          <TabPanel value={tab} index={2} sx={fixedTabSx}>
            <Box sx={fixedChildSx}>
              <ProductSupplierInfoPage />
            </Box>
          </TabPanel>

          <TabPanel value={tab} index={3} sx={fixedTabSx}>
            <Box sx={fixedChildSx}>
              <RawMaterialConsumption />
            </Box>
          </TabPanel>
        </Box>
      </Box>
    );
  }
}

export default InventorySupplyTabs;
